<template>
  <div class="prep-budget-item-card-wrap">
    <div
      class="prep-budget-item-card"
      :class="{ 'prep-budget-item-card-fill': fillMode }"
    >
      <button
        v-if="showDragHandle"
        type="button"
        class="prep-drag-handle"
        title="Sorrend módosítása"
        aria-label="Sorrend módosítása"
      >
        <feather-icon
          icon="MoveIcon"
          size="16"
        />
      </button>
      <div class="prep-budget-item-text">
        {{ itemText }}
        <div
          v-if="showNoteAction || showActions || showRemoveAction"
          class="prep-item-actions"
        >
          <button
            v-if="showNoteAction"
            type="button"
            class="prep-item-action-btn note"
            :class="{ active: hasNote }"
            :title="hasNote ? notePreview : 'Megjegyzés hozzáadása'"
            @click="openNoteModal"
          >
            <feather-icon
              icon="MessageSquareIcon"
              size="14"
            />
          </button>
          <button
            v-if="showActions"
            type="button"
            class="prep-item-action-btn"
            title="Tétel szöveg szerkesztése"
            @click="$emit('edit-item-text', { item_id: itemId, item_text: itemText })"
          >
            <feather-icon
              icon="Edit2Icon"
              size="14"
            />
          </button>
          <button
            v-if="showActions"
            type="button"
            class="prep-item-action-btn danger"
            title="Almenü kapcsolat törlése"
            @click="$emit('unlink-subgroup', { item_id: itemId })"
          >
            <feather-icon
              icon="XIcon"
              size="14"
            />
          </button>
          <button
            v-if="showRemoveAction"
            type="button"
            class="prep-item-action-btn danger"
            title="TĂ©tel tĂ¶rlĂ©se a kĂˇrtyĂˇbĂłl"
            @click="$emit('remove-item', { item_id: itemId })"
          >
            <feather-icon
              icon="Trash2Icon"
              size="14"
            />
          </button>
        </div>
      </div>
      <div class="prep-budget-item-fields">
        <label class="prep-budget-item-field">
          <span>Menny.</span>
          <input
            v-model="local.qty"
            type="number"
            class="prep-input"
            :readonly="!canEditQty"
            @input="emitChange"
          >
        </label>
        <label class="prep-budget-item-field">
          <span>Egys.</span>
          <input
            v-model="local.unit"
            type="text"
            class="prep-input"
            :readonly="!canEditUnit"
            @dblclick="enableUnitEditing"
            @input="emitChange"
          >
        </label>
        <label
          v-if="!fillMode && !hideMaterialColumns"
          class="prep-budget-item-field"
        >
          <span>{{ summaryMode ? 'Anyag összesen' : 'Anyag egységár' }}</span>
          <input
            :value="formatFt(local.material_unit_price)"
            type="text"
            class="prep-input"
            :readonly="!canEditMoney"
            @input="onMoneyInput('material_unit_price', $event.target.value)"
          >
        </label>
        <label
          v-if="!fillMode"
          class="prep-budget-item-field"
        >
          <span>{{ summaryMode ? 'Díj összesen' : 'Alap Díj egységre' }}</span>
          <input
            :value="formatFt(local.base_fee_unit)"
            type="text"
            class="prep-input"
            :readonly="!canEditMoney"
            @input="onMoneyInput('base_fee_unit', $event.target.value)"
          >
        </label>
        <label
          v-if="!fillMode && !summaryMode && !hideMaterialColumns"
          class="prep-budget-item-field"
        >
          <span>Anyag összesen</span>
          <input
            :value="formatFt(local.material_total)"
            type="text"
            class="prep-input"
            readonly
          >
        </label>
        <label
          v-if="!fillMode && !summaryMode"
          class="prep-budget-item-field"
        >
          <span>Díj összesen</span>
          <input
            :value="formatFt(local.fee_total)"
            type="text"
            class="prep-input"
            readonly
          >
        </label>
        <label
          v-else-if="!fillMode"
          class="prep-budget-item-field"
        >
          <span>Anyag + Díj összesen</span>
          <input
            :value="formatFt(combinedTotal)"
            type="text"
            class="prep-input"
            readonly
          >
        </label>
        <label
          v-if="!fillMode && showPlannedExpenseControl"
          class="prep-budget-item-field prep-budget-item-field-checkbox"
        >
          <span>Valós anyag költség</span>
          <input
            v-model="local.planned_material_cost"
            type="checkbox"
            class="prep-checkbox"
            @change="emitChange"
          >
        </label>
      </div>
    </div>
    <div
      v-if="noteModalOpen"
      class="prep-note-modal-backdrop"
      @click.self="closeNoteModal"
    >
      <div class="prep-note-modal">
        <div class="prep-note-modal-header">
          <div>
            <div class="prep-note-modal-title">
              Tétel megjegyzés
            </div>
            <div class="prep-note-modal-subtitle">
              Belső emlékeztető ehhez a tételhez
            </div>
          </div>
          <button
            type="button"
            class="prep-note-close"
            title="Bezárás"
            @click="closeNoteModal"
          >
            x
          </button>
        </div>
        <textarea
          v-model="noteDraft"
          class="prep-note-textarea"
          rows="6"
          placeholder="Írd ide a megjegyzést..."
        />
        <div class="prep-note-footer">
          <button
            v-if="hasDraftNote"
            type="button"
            class="prep-note-btn prep-note-btn-danger"
            @click="clearNote"
          >
            Törlés
          </button>
          <span v-else />
          <div class="prep-note-footer-actions">
            <button
              type="button"
              class="prep-note-btn"
              @click="closeNoteModal"
            >
              Mégse
            </button>
            <button
              type="button"
              class="prep-note-btn prep-note-btn-primary"
              @click="saveNote"
            >
              Mentés
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BudgetItemCard',
  props: {
    itemId: {
      type: [Number, String],
      default: null,
    },
    itemText: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    summaryMode: {
      type: Boolean,
      default: false,
    },
    hideMaterialColumns: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    showRemoveAction: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: String,
      default: 'full',
    },
    showPlannedExpenseControl: {
      type: Boolean,
      default: true,
    },
    showDragHandle: {
      type: Boolean,
      default: false,
    },
    showNoteAction: {
      type: Boolean,
      default: false,
    },
    fillMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      local: {
        qty: '',
        unit: '',
        material_unit_price: '',
        base_fee_unit: '',
        material_total: '',
        fee_total: '',
        planned_material_cost: false,
        internal_note: '',
      },
      unitEditEnabled: false,
      noteModalOpen: false,
      noteDraft: '',
    }
  },
  computed: {
    hasNote() {
      return String(this.local.internal_note || '').trim() !== ''
    },
    hasDraftNote() {
      return String(this.noteDraft || '').trim() !== ''
    },
    notePreview() {
      const note = String(this.local.internal_note || '').trim()
      if (!note) return 'Megjegyzés hozzáadása'
      return note.length > 120 ? `${note.slice(0, 120)}...` : note
    },
    canEditQty() {
      return this.editMode !== 'readonly'
    },
    canEditUnit() {
      if (this.editMode === 'readonly') return false
      if (this.fillMode) return true
      if (this.editMode === 'qty-only') return this.unitEditEnabled
      return true
    },
    canEditMoney() {
      return this.editMode === 'full'
    },
    combinedTotal() {
      const material = this.local.material_total === '' || this.local.material_total === null || this.local.material_total === undefined
        ? 0
        : Number(this.local.material_total)
      const fee = this.local.fee_total === '' || this.local.fee_total === null || this.local.fee_total === undefined
        ? 0
        : Number(this.local.fee_total)
      return Number.isFinite(material + fee) ? material + fee : ''
    },
  },
  watch: {
    value: {
      handler(val) {
        const v = val || {}
        this.local = {
          qty: v.qty ?? '',
          unit: v.unit ?? '',
          material_unit_price: v.material_unit_price ?? '',
          base_fee_unit: v.base_fee_unit ?? '',
          material_total: v.material_total ?? '',
          fee_total: v.fee_total ?? '',
          planned_material_cost: (v.planned_expense_scope || 'none') === 'material',
          internal_note: v.internal_note ?? '',
        }
      },
      immediate: true,
      deep: true,
    },
    editMode() {
      this.unitEditEnabled = false
    },
    fillMode() {
      this.unitEditEnabled = false
    },
  },
  methods: {
    enableUnitEditing() {
      if (this.editMode !== 'qty-only') return
      this.unitEditEnabled = true
    },
    openNoteModal() {
      this.noteDraft = this.local.internal_note || ''
      this.noteModalOpen = true
    },
    closeNoteModal() {
      this.noteModalOpen = false
      this.noteDraft = ''
    },
    clearNote() {
      this.noteDraft = ''
      this.saveNote()
    },
    saveNote() {
      this.local.internal_note = String(this.noteDraft || '').trim()
      this.emitChange()
      this.closeNoteModal()
    },
    formatFt(value) {
      if (value === '' || value === null || value === undefined) return ''
      const n = Number(value)
      if (!Number.isFinite(n)) return ''
      const rounded = Math.round(n)
      return `${rounded.toLocaleString('hu-HU')} Ft`
    },
    parseFt(value) {
      const raw = String(value || '').trim()
      if (!raw) return null
      const normalized = raw
        .replace(/Ft/gi, '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
      if (normalized === '' || normalized === '-') return null
      const parsed = Number(normalized)
      return Number.isFinite(parsed) ? parsed : null
    },
    onMoneyInput(field, rawValue) {
      if (!this.canEditMoney) return
      this.local[field] = this.parseFt(rawValue)
      this.emitChange()
    },
    emitChange() {
      this.$emit('change', {
        item_id: this.itemId,
        qty: this.local.qty === '' ? null : this.local.qty,
        unit: this.local.unit === '' ? null : this.local.unit,
        material_unit_price: this.local.material_unit_price === '' ? null : this.local.material_unit_price,
        base_fee_unit: this.local.base_fee_unit === '' ? null : this.local.base_fee_unit,
        material_total: this.local.material_total === '' ? null : this.local.material_total,
        fee_total: this.local.fee_total === '' ? null : this.local.fee_total,
        planned_expense_scope: this.local.planned_material_cost ? 'material' : 'none',
        internal_note: this.local.internal_note || '',
      })
    },
  },
}
</script>

<style scoped>
.prep-budget-item-text {
  position: relative;
}

.prep-budget-item-card-fill .prep-budget-item-text {
  flex: 1 1 auto;
}

.prep-budget-item-card-fill .prep-budget-item-fields {
  flex: 0 0 min(24rem, 36%);
  display: flex;
  flex-wrap: nowrap;
}

.prep-budget-item-card-fill .prep-budget-item-field {
  flex: 1 1 0;
}

.prep-drag-handle {
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  border: 1px solid color-mix(in srgb, var(--prep-accent-soft) 34%, rgba(148, 163, 184, 0.35) 66%);
  border-radius: 8px;
  background:
    linear-gradient(140deg, color-mix(in srgb, var(--prep-surface-1) 82%, #fff 18%) 0%, var(--prep-surface-2) 100%);
  color: color-mix(in srgb, var(--prep-text) 88%, #ffffff 12%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  padding: 0;
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.prep-drag-handle:hover {
  border-color: color-mix(in srgb, var(--prep-accent-base) 48%, rgba(148, 163, 184, 0.35) 52%);
  box-shadow: 0 6px 14px color-mix(in srgb, var(--prep-accent-base) 28%, transparent 72%);
  transform: translateY(-1px);
}

.prep-drag-handle:active {
  cursor: grabbing;
}

.prep-item-actions {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  display: flex;
  gap: 0.3rem;
}

.prep-item-action-btn {
  border: 1px solid color-mix(in srgb, var(--prep-accent-soft) 28%, rgba(148, 163, 184, 0.35) 72%);
  background:
    linear-gradient(140deg, color-mix(in srgb, var(--prep-surface-1) 82%, #fff 18%) 0%, var(--prep-surface-2) 100%);
  color: color-mix(in srgb, var(--prep-text) 88%, #ffffff 12%);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

.prep-budget-item-field-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.prep-checkbox {
  width: 1rem;
  height: 1rem;
  accent-color: #4ade80;
  cursor: pointer;
}

.prep-item-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px color-mix(in srgb, var(--prep-accent-base) 28%, transparent 72%);
}

.prep-item-action-btn.note.active {
  color: #facc15;
  border-color: color-mix(in srgb, #facc15 55%, rgba(148, 163, 184, 0.35) 45%);
  box-shadow: 0 0 0 1px color-mix(in srgb, #facc15 25%, transparent 75%);
}

.prep-item-action-btn.danger {
  color: color-mix(in srgb, var(--prep-danger-base) 82%, #ffd0d0 18%);
  border-color: color-mix(in srgb, var(--prep-danger-base) 36%, rgba(248, 113, 113, 0.35) 64%);
}

.prep-item-action-btn.danger:hover {
  box-shadow: 0 6px 14px color-mix(in srgb, var(--prep-danger-base) 34%, transparent 66%);
}

.prep-note-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2100;
  background: rgba(2, 6, 23, 0.68);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.prep-note-modal {
  width: min(520px, 100%);
  background: linear-gradient(145deg, #172034 0%, #101827 100%);
  border: 1px solid color-mix(in srgb, var(--prep-accent-soft) 28%, rgba(148, 163, 184, 0.35) 72%);
  border-radius: 12px;
  box-shadow: 0 24px 60px rgba(2, 6, 23, 0.45);
  color: var(--prep-text);
  padding: 1rem;
}

.prep-note-modal-header,
.prep-note-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.prep-note-modal-title {
  font-size: 1rem;
  font-weight: 700;
}

.prep-note-modal-subtitle {
  color: var(--prep-muted);
  font-size: 0.8rem;
  margin-top: 0.15rem;
}

.prep-note-close {
  border: 0;
  background: transparent;
  color: var(--prep-muted);
  cursor: pointer;
  font-size: 1.15rem;
  line-height: 1;
}

.prep-note-textarea {
  width: 100%;
  min-height: 160px;
  resize: vertical;
  margin: 1rem 0;
  border-radius: 10px;
  border: 1px solid var(--prep-field-stroke);
  background: color-mix(in srgb, var(--prep-surface-1) 88%, #ffffff 12%);
  color: var(--prep-text);
  padding: 0.75rem;
  line-height: 1.45;
}

.prep-note-textarea:focus {
  outline: none;
  border-color: var(--prep-accent-soft);
  box-shadow: 0 0 0 2px var(--prep-focus-ring);
}

.prep-note-footer-actions {
  display: flex;
  gap: 0.5rem;
}

.prep-note-btn {
  border: 1px solid color-mix(in srgb, var(--prep-accent-soft) 25%, rgba(148, 163, 184, 0.35) 75%);
  background: color-mix(in srgb, var(--prep-surface-1) 84%, #ffffff 16%);
  color: var(--prep-text);
  border-radius: 8px;
  padding: 0.45rem 0.9rem;
  cursor: pointer;
}

.prep-note-btn-primary {
  background: #2563eb;
  border-color: #3b82f6;
  color: #fff;
}

.prep-note-btn-danger {
  color: #fecaca;
  border-color: color-mix(in srgb, var(--prep-danger-base) 45%, rgba(248, 113, 113, 0.35) 55%);
}
</style>
